import React from 'react';
import { faCashRegister } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { CashDrawerOption } from '../../../../services/payments/payments.service';
import { PickListModal } from '../../../../components/PickListModal/PickListModal';

export type CashDrawerPickPrompt = { drawers: CashDrawerOption[] };

export type CashDrawerPickModalProps = {
  prompt: CashDrawerPickPrompt | null;
  disabled: boolean;
  dataTestId?: string;
  onPick: (drawerId: number) => void;
  onClose: () => void;
};

// Summary: Cash-drawer picker — a thin cash-drawer-typed wrapper over the shared PickListModal.
const CashDrawerPickModalComponent: React.FC<CashDrawerPickModalProps> = ({ prompt, disabled, dataTestId, onPick, onClose }) => (
  <PickListModal
    title="בחר מגירה"
    icon={faCashRegister as IconProp}
    options={prompt?.drawers ?? null}
    disabled={disabled}
    dataTestId={dataTestId}
    optionColor="success"
    onPick={onPick}
    onClose={onClose}
  />
);

export const CashDrawerPickModal = React.memo(CashDrawerPickModalComponent);
